// T stands for title :)
export const performanceT =
  "Performance is about measuring how quickly a browser can assemble a webpage.";
export const seoT =
  "SEO means Search Engine Optimization and is the process used to optimize a website's technical configuration, content relevance and link popularity so its pages can become easily findable, more relevant and popular towards user search queries";
export const accessibilityT =
  "Accessibility is the practice of making your websites usable by as many people as possible. We traditionally think of this as being about people with disabilities, but the practice of making sites accessible also benefits other groups such as those using mobile devices, or those with slow network connections.";
export const FinalScreenShotT =
  "The final Screen Shot is how your website looks after being painted by the browser";
